@if (isEmpty()) {
  <div class="echarts-empty-state" [ngClass]="customCss()" [ngStyle]="customStyle() ?? {}" (click)="openEditor()">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="empty-icon"
    >
      <path d="M3 3v18h18" />
      <path d="M7 14l4-4 3 3 5-7" />
    </svg>
    <p class="empty-title">Click to edit</p>
    <p class="empty-hint">
      Configure your ECharts chart, or
      <a [href]="docsUrl" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()"
        >view the documentation</a
      >
    </p>
  </div>
} @else {
  <div class="echarts-wrapper" [ngClass]="customCss()" [ngStyle]="customStyle() ?? {}">
    <dojo-echarts-svg [options]="options()" [style.height.px]="height()" />
    @if (editor().isEditable) {
      <button class="edit-btn" (click)="openEditor()" title="Edit ECharts">
        <dojo-icon icon="pen-to-square" [size]="14" />
      </button>
    }
  </div>
}

@if (editor().isEditable) {
  <dojo-echarts-editor
    [options]="options()"
    [height]="height()"
    [isOpen]="showEditor()"
    (optionsChange)="onOptionsChange($event)"
    (editorClose)="closeEditor()"
  />
}
